
    /**
    * 短信验证码登陆
    * 
    **/
    
    // @ts-nocheck
    import request from '../utils/http'
    type Serve<T, G> = (data?: T) => Promise<G>
    /**
 * OfficalSmsLoginParam :OfficalSmsLoginParam
 */
export class IReqApiEmployeeSmsLogin28742 {
  /**
   * 短信验证码
   */
  smsCode: string;
  /**
   * 线索编号
   */
   mobile: string;
}
    /**
 * YResult<OfficalSmsLoginResp> :YResult
 */
export class IResApiEmployeeSmsLogin28742 {
  code?: {};
  msg?: {};
  success?: {};
  /**
   * OfficalSmsLoginResp
   */
  data?: {
    /**
     * 临时token,失效时间至当天24点
     */
    tmpToken?: string;
  };
  exceptionMsg?: {};
}
    const http: Serve<IReqApiEmployeeSmsLogin28742, IResApiEmployeeSmsLogin28742> = (data?) =>  request({
      method: 'POST',
      url: '/api/employee/sms/login',
      data:data,
      headers:{'Content-Type': 'application/json;charset=UTF-8'}
    }) 
    export default http